/**
 * JS for share buttons
 */
jQuery(document).ready(function ($) {
    // Iterate through share components
    $('.bocss-share').each(function () {
        // Open share in a new window, excluding email links
        $(this).find('.bocss-button').not("a[href*='mailto:']").click(function (event) {
            // Prevent default anchor functionality
            event.preventDefault();
            // Open window
            window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
        });
    });
});
